import styled from 'styled-components';
import {GridWrapper, mediaQueries} from '@/theme/lib';

import {DownloadButtonsProps} from '@components/DownloadButtons';

export const StyledDownloadButtons = styled(GridWrapper)<DownloadButtonsProps>`
  .download-buttons__list {
    display: flex;
    flex-direction: column;
    ${mediaQueries.md} {
      flex-flow: row wrap;
      gap: 2rem;
    }
    &-item {
      display: inline-block;
      margin-bottom: 1rem;
      ${mediaQueries.md} {
        margin-bottom: 0;
      }
    }
  }
`;
